import React from 'react';
import { connect } from 'react-redux';
import { Definitions } from '../../../../../_helpers/question-definitions'

import AgeCard from './Cards/Age';
import DateCard from './Cards/Date';
import YesNoCard from './Cards/YesNo';
import GenderCard from './Cards/Gender';
import ChoiceCard from './Cards/Choice';
import IntegerCard from './Cards/Integer';
import DisplayCard from './Cards/Display';
import LongTextCard from './Cards/LongText';
import LastNameCard from './Cards/LastName';
import FirstNameCard from './Cards/FirstName';
import PainScaleCard from './Cards/PainScale';
import ShortTextCard from './Cards/ShortText';
import OpenChoiceCard from './Cards/OpenChoice';
import AttachmentCard from './Cards/Attachment';

const Questions = ({ items }) => {
  const containsGender = items.find(item => {
    return item.definition === Definitions.GENDER
  });

  return (
    <div className="row row-cols-1">
      <div className="col mb-2">
        <h5 style={{ borderBottom: '4px solid #1AB2E9' }}>HPI Questions</h5>
      </div>

      <div className="col pt-3" style={{ height: '600px', overflow: 'scroll' }}>
        <FirstNameCard />
        <LastNameCard />
        <AgeCard />

        {containsGender && <GenderCard />}

        {items.map((question, i) => {
          if (question.definition === Definitions.FIRST_NAME || question.definition === Definitions.LAST_NAME || question.definition === Definitions.GENDER) {
            return null;
          }

          switch (question.type) {
            case 'date':
              return <DateCard key={i} question={question} />;
            case 'choice':
              return <ChoiceCard key={i} question={question} />;
            case 'display':
              return <DisplayCard key={i} question={question} />;
            case 'text':
              return <LongTextCard key={i} question={question} />;
            case 'open-choice':
              return <OpenChoiceCard key={i} question={question} />;
            case 'pain-scale':
              return <PainScaleCard key={i} question={question} />;
            case 'attachment':
              return <AttachmentCard key={i} question={question} />;
            case 'string':
              return <ShortTextCard key={i} question={question} />;
            case 'boolean':
              return <YesNoCard key={i} question={question} />;
            case 'integer':
              return <IntegerCard key={i} question={question} />
            default:
              return false;
          }
        })}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    items: state.questionnaire.current.item.filter((item) => {
      const isNote = item.extension.find((extension) => {
        return extension.url === 'https://axshealthapp.com/fhir/StructureDefinition/questionnaire-item-note' &&
          extension.valueBoolean;
      })

      return isNote;
    })
  }
}

export default connect(mapStateToProps)(Questions);